import { render, staticRenderFns } from "./Dendogram.vue?vue&type=template&id=883b76dc"
import script from "./Dendogram.vue?vue&type=script&lang=js"
export * from "./Dendogram.vue?vue&type=script&lang=js"
import style0 from "./Dendogram.vue?vue&type=style&index=0&id=883b76dc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports